import { CardGroup } from '@ps/sports-ui-component-library';
import { Translation } from '@ps/web-shared-components';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { ExpandablePanel, Overlay } from '@swf/sports/components';

import Title from '../../../Title/Title';
import Opportunity from '../Opportunity/Opportunity';

import { TXTWCL_Singles } from './SingleOpportunities.messages.json';
import styles from './SingleOpportunities.scss';
import SkeletonOpportunity from './SkeletonOpportunity';

const SingleOpportunities: React.FC = () => {
  const opportunities = useSelector(select.betSlip.singleOpportunities);
  const pendingSelectionCount = useSelector(select.betSlip.pendingSelectionCount);

  if (!opportunities.length && !pendingSelectionCount) return null;

  const skeletonCards = [...Array(pendingSelectionCount).keys()];

  return (
    <ExpandablePanel
      title={
        <Title count={opportunities.length + pendingSelectionCount || undefined}>
          <Translation {...TXTWCL_Singles} />
        </Title>
      }
    >
      <CardGroup condensed padded>
        {opportunities.map((opportunity) => (
          <div className={styles.cardGroup} key={opportunity.id}>
            <Overlay />
            <Opportunity opportunity={opportunity} />
          </div>
        ))}
        {skeletonCards.map((skeletonCard) => (
          <SkeletonOpportunity key={skeletonCard} />
        ))}
      </CardGroup>
    </ExpandablePanel>
  );
};

export default memo(SingleOpportunities);
